import { render, staticRenderFns } from "./reevaluacion-hogar-resumen.vue?vue&type=template&id=98fa0c9c&"
import script from "./reevaluacion-hogar-resumen.vue?vue&type=script&lang=ts&"
export * from "./reevaluacion-hogar-resumen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports